import { SelectionChangedEvent } from "ag-grid-community";
import { INITIAL_ADDITIONAL_CHARGE_VESSEL_COL_DEF, transferRowData } from "presentation/constant/CounterCustomerCharge/AdditionalChargeVesselColumnDefinition";
import { WorkspaceConstant } from "presentation/constant/WorkSpaceConstant";
import { useCounterCustomerChargeMaintenanceVM } from "presentation/hook/CounterCustomerCharge/useCounterCustomerChargeMaintenanceVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useCounterCustomerChargeMaintenanceTracked } from "presentation/store/CounterCustomerCharge/CounterCustomerChargeMaintenanceProvider";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useMemo, useRef, useState } from "react";
import { HPHButton, Loader } from "veronica-ui-component/dist/component/core";
import { StyledAction } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

export const AdditionalChargeVesselTablePanel = () => {
    const [counterCustomerChargeState] = useCounterCustomerChargeMaintenanceTracked();
    const counterCustomerChargeVM = useCounterCustomerChargeMaintenanceVM();
    const [anaInfoState] = useANAInfoTracked();
    const { allowUpdate } = anaInfoState;
    const { additionalState } = counterCustomerChargeState;
    const gridRef: any = useRef();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const messageBarVM = useMessageBarVM();
    const tableId = 'manual-charge-dtl-cntr-records-table';

    const handleApply = useCallback(async () => {
        if (!additionalState.currentSelectedVesselRow) {
            messageBarVM.showError('Please select a record.');
            return;
        }

        setIsLoading(true);
        counterCustomerChargeVM.applyVessel(additionalState.currentSelectedVesselRow);
        setIsLoading(false);
    }, [additionalState.currentSelectedVesselRow, messageBarVM, counterCustomerChargeVM]);

    const isDisableApply = () => {
        //return selectedManualChargeDetailVesselRow.length === 0;
        return false;
    }

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        const selectedRows = e.api.getSelectedRows();
        counterCustomerChargeVM.updateAdditionalVesselSelectedRows(selectedRows);
    }, [counterCustomerChargeVM])

    const memoManualChargeDetailVesselTable = useMemo(() => {
        return <NbisTable
            id={tableId}
            isNewColumnSetting={true}
            columns={INITIAL_ADDITIONAL_CHARGE_VESSEL_COL_DEF?.slice()}
            data={transferRowData(additionalState.vesselTableData)}
            showPaginator={false}
            editable={false}
            showAddIcon={false}
            showDeleteButton={false}
            showReloadIcon={false}
            isScrollHighlighted={true}
            isRowHighligted={true}
            selectionMode={false}
            handleSelectionChanged={handleSelectionChange}
            gridHeight="customHeight"
            customHeight="calc(59vh)"
            ref={gridRef}
        />
    }, [additionalState.vesselTableData, handleSelectionChange])

    if (isLoading) return <Loader Indicator="Stripe" size="Large" />;

    return <>{<TableWrapper>{memoManualChargeDetailVesselTable}
        {<StyledAction className="tm-animated-wrapper">
            {(allowUpdate) && <HPHButton disabled={isDisableApply()} label={WorkspaceConstant.Common.BUTTON_UPDATE} size={'Small'} theme={'Primary'} onClick={handleApply} />}
        </StyledAction>}
    </TableWrapper>}</>;
}

export default memo(AdditionalChargeVesselTablePanel);